<template>
  <teleport to="body">
    <transition name="modal" appear>
      <div v-if="modelValue" class="modal" @keydown.esc.window.prevent="close">
        <div class="modal__background" @click="close">
          <div class="modal__container" @click.stop>
            <button class="modal__close" @click="close" aria-label="Close">
              <Icon
                svgClass="modal-close__svg"
                name="close"
                size="25"
              />
            </button>

            <!-- Header слот -->
            <div v-if="$slots.header" class="modal__header">
              <slot name="header" />
            </div>

            <!-- Основной контент -->
            <div class="modal__body">
              <slot />
            </div>

            <!-- Footer слот -->
            <div v-if="$slots.footer" class="modal__footer">
              <slot name="footer" />
            </div>
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
export default {
  name: "AppModal",
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue"],
  methods: {
    close() {
      this.$emit("update:modelValue", false);
    }
  }
};
</script>

<style scoped>
.modal-close__svg {
	width: 2rem;
	height: 2rem;	
}

.modal {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal {
  z-index: 99999 !important;
  pointer-events: auto;
}

.modal__background,
.modal__container {
  pointer-events: auto;
}
.modal__background {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,0.5);
}

.modal__container {
  width: 90%;
  max-width: 31.25rem;
  background-color: var(--grey-1, #fff);
  border-radius: 0.5rem;
  min-height: 12rem;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  z-index: 1;
  display: flex;
  flex-direction: column;
}

/* Кнопка закрытия */
.modal__close {
  position: absolute;
	top: 0.8rem;
  right: 0.5rem;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  line-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text);
  transition: all 0.3s ease;
}
.modal__close:hover {
  opacity: 0.5
}

.modal__header {
	border-bottom: 0.1rem solid var(--grey-0);
  font-weight: bold;
  padding: 1rem;
  text-align: left;
}
.modal__body {
  flex: 1;
	padding: 1rem;
  overflow-y: auto;
}
.modal__footer {
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
  border-top: 0.1rem solid var(--grey-0);
  padding: 1rem;
}

/* Адаптивность */
@media (min-width: 40rem) { /* 640px */
  .modal__container {
    width: 80%;
    max-width: 43.75rem; /* 700px */
    min-height: 16rem;
  }
}

@media (min-width: 64rem) { /* 1024px */
  .modal__container {
    width: 70%;
    max-width: 75rem; /* 1200px */
    min-height: 20rem;
  }
}

/* Transition для анимации */
.modal-enter-active .modal__background,
.modal-leave-active .modal__background {
  transition: opacity 0.3s ease;
}
.modal-enter-from .modal__background,
.modal-leave-to .modal__background {
  opacity: 0;
}

.modal-enter-active .modal__container,
.modal-leave-active .modal__container {
  transition: transform 0.3s cubic-bezier(.2,.8,.2,1), opacity 0.22s ease;
}
.modal-enter-from .modal__container,
.modal-leave-to .modal__container {
  transform: translateY(-0.75rem) scale(0.98); /* -12px */
  opacity: 0;
}

@media (max-width: 768px) {
  .modal {
    font-size: 10px;
  }
}
</style>
